<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="irrigation" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Smart Farm Solution
            </template>
            <tit-wrap-large>
                A system that facilitates field management <br class="d-none d-lg-block" /><b>Integrated Smart Irrigation Control System</b>
                <template #text>The system saves water by diagnosing the current state of the field and supplying the proper amount of water as much as needed. <br class="d-none d-lg-block" />It also promotes crop growth through optimized smart irrigation control based on time, flow rate, water content deviations, etc.</template>
            </tit-wrap-large>

            <v-img max-width="528" :aspect-ratio="528 / 786" src="/images/sub/solution/smartfarm/irrigation-img.png" class="mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex pa-20px">
                                    <v-img max-width="242" :aspect-ratio="242 / 348" src="/images/sub/solution/smartfarm/irrigation-img2.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    Smart water control system
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Control items</template>
                                    Time, amount of light, and weight
                                    <div class="font-size-16 font-size-md-18">*Weight control-based nutrient solution management algorithm</div>
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Irrigation types</template>
                                    Time-based irrigation, flow rate-based irrigation, and water content-based irrigation
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Settings</template>
                                    Zone settings (up to 10)<br />Irrigation intervals by zone<br />Irrigation period<br />EC and pH settings by zone<br />Amount of irrigation in each stock of crop<br />Upper and lower limit alarm of EC and pH
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Lookup item</template>
                                    Nutrient solution supply machine operation record, root zone monitoring record, and real-time greenhouse environment data, greenhouse environment data by time
                                </txt-item>
                                <txt-item titleClass="w-md-140px">
                                    <template #title>Other functions</template>
                                    Manual irrigation for emergency
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="600" :width="$vuetify.breakpoint.lgAndUp ? '600' : ''" :aspect-ratio="600 / 376" src="/images/sub/solution/smartfarm/irrigation-img3.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        Easy and simple real-time monitoring via the Internet and mobile device
                                        <template #text>The system helps you set and decide the cultivation environment conditions through a variety of records such as operational data of the nutrient solution supply machine, root zone monitoring data, and greenhouse environment data.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/irrigation-img4.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                 Registered Patent
                                <template #text>
                                    Apparatus for Managing Nutriculture
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <page-section class="grey lighten-5">
            <page-section class="page-section--sm py-0">
                <tit-wrap-large class="tit-wrap--lg"><b>All-in-one smart irrigation solution</b> <br class="d-none d-lg-block" />that manages the root zone environment</tit-wrap-large>

                <v-row align="center" justify="center" class="row--lg">
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="100">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">Applies an irrigation system based on the water content of root zones</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="200">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">Creates irrigation control algorithms through data learning on the root zones</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="300">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">Provides an integrated solution through root zone measurement</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                </v-row>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <v-img max-width="966" :aspect-ratio="966 / 680" src="/images/sub/solution/smartfarm/irrigation-img5-en.png" class="ma-auto" data-aos="fade" data-aos-delay="400" />
            </page-section>
        </page-section>

        <page-section id="irrigation-portfolio" class="page-section--last">
            <template #title>
                Portfolio
            </template>
            <div></div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <irrigation-slide />
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import IrrigationSlide from "@/pages/client/sub/solution/IrrigationSlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        IrrigationSlide,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
